import React, { useCallback, useEffect, useMemo } from 'react';
import { useMutation, useQuery } from '@apollo/client';
import { Form } from 'antd';
import DefaultModal from './DefaultModal';
import { openNotification } from 'src/components/common/Notification';
import CreateConsultForm from 'src/pages/Consulting/CreateConsultForm';
import { MOD_CONSULT } from 'src/operations/mutations/consult';
import { GET_CONSULT_LIST, GET_ORDER } from 'src/operations/queries/consult';

const ConsultFormModal = ({ onCancel, order_idx, campus_idx, visible, searchMonth, refetch, ...rest }) => {
  const [form] = Form.useForm();
  const { data: dataOrder } = useQuery(GET_ORDER, { skip: !order_idx, variables: { idx: order_idx } });
  console.log('dataOrder', dataOrder, order_idx);
  const [modConsult, { loading: loadingCreate }] = useMutation(MOD_CONSULT, {
    onCompleted: () => {
      refetch();
      openNotification('수정 완료!');
      handleCancel();
    },
    onError(error) {
      alert('error');
      console.log('error', error);
    },
    // refetchQueries: [
    //   {
    //     query: GET_CONSULT_LIST,
    //     variables: { campus_idx, ym: searchMonth },
    //   },
    // ],
  });

  useEffect(() => {
    if (dataOrder && visible) {
      form.setFieldsValue({
        student_name: dataOrder.orderItemByIdx.name,
        phone: dataOrder.orderItemByIdx.parent_phone,
      });
    }
  }, [dataOrder, form, visible]);
  const handleSubmit = useCallback(
    (values) => {
      const { phone, student_name } = values;
      modConsult({ variables: { order_idx, phone, student_name } });
    },
    [order_idx, modConsult],
  );
  const handleCancel = useCallback(() => {
    form.resetFields();
    onCancel();
  }, [form, onCancel]);
  return (
    <DefaultModal
      title="예약 정보 수정"
      form={form}
      loading={loadingCreate}
      ActionCancel={handleCancel}
      popupMode="mod"
      width={60}
      visible={visible}
      {...rest}
    >
      {/* create 가 아니라 수정임.. 헐..*/}
      <CreateConsultForm form={form} onFinish={handleSubmit} />
    </DefaultModal>
  );
};

export default ConsultFormModal;
